<template>
  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
    class="min-w-0 max-w-full"
  >
    <div
      class="w-full min-w-0 max-w-full flex flex-col gap-2 py-4 md:py-4 md:px-4"
    >
      <div
        class="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm min-w-0 max-w-full overflow-hidden"
      >
        <div
          class="flex items-center justify-between mb-4 pb-3 border-b border-slate-100"
        >
          <div class="flex items-center gap-2">
            <i class="fa-solid fa-rotate text-emerald-600"></i>
            <h3 class="font-bold text-slate-800 text-lg m-0">
              Live Casino Spins
            </h3>
          </div>
        </div>

        <RoundFinder
          :customColumns="spinColumns"
          :customFilters="spinFilters"
          :modalComponent="LiveCasinoRoundModal"
          endpointProps="spins/roulette/"
          resourceNameProps="spins"
          defaultSortField="created_at"
          :defaultSortOrder="-1"
        >
          <!-- Amount / Amount Converted -->
          <template #col-amount="{ data }">
            <span class="text-xs font-semibold text-slate-800">
              {{
                data.amount !== undefined && data.amount !== null
                  ? parseFloat(data.amount).toFixed(2) +
                    ` ${data.currency_code || ""}`
                  : "-"
              }}
              <span
                v-if="
                  data.amount_converted !== undefined &&
                  data.amount_converted !== null
                "
                class="text-slate-400 font-normal ml-1"
                title="Amount Converted"
              >
                / {{ parseFloat(data.amount_converted).toFixed(2) }} EUR
              </span>
            </span>
          </template>

          <!-- Win / Win Converted -->
          <template #col-win="{ data }">
            <span
              :class="[
                'text-xs font-bold',
                parseFloat(data.win) > 0
                  ? 'text-emerald-600'
                  : 'text-slate-600',
              ]"
            >
              {{
                data.win !== undefined && data.win !== null
                  ? parseFloat(data.win).toFixed(2) +
                    ` ${data.currency_code || ""}`
                  : "-"
              }}
              <span
                v-if="
                  data.win_converted !== undefined &&
                  data.win_converted !== null
                "
                class="text-slate-400 font-normal ml-1"
                title="Win Converted"
              >
                / {{ parseFloat(data.win_converted).toFixed(2) }} EUR
              </span>
            </span>
          </template>

          <!-- Bet Types Count -->
          <template #col-type="{ data }">
            <span
              class="px-2 py-0.5 bg-slate-100 border border-slate-200 rounded-md text-xs font-semibold text-slate-700 inline-flex items-center gap-1"
              :title="`${data.type?.length || 0} bet type(s)`"
            >
              <i class="fa-solid fa-layer-group text-slate-400 text-[10px]"></i>
              {{ data.type?.length || 0 }}
            </span>
          </template>
        </RoundFinder>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import RoundFinder from "@/slot/components/round/RoundFinder.vue";
import LiveCasinoRoundModal from "../components/LiveCasinoRoundModal.vue";

const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);

const spinColumns = ref([
  {
    slug: "user_id",
    label: "Player ID",
    type: "player_link",
    sortable: true,
  },
  {
    slug: "uuid",
    label: "Bet ID",
    sortable: true,
  },
  {
    slug: "roundId",
    label: "Round ID",

    sortable: true,
  },
  {
    slug: "game_id",
    label: "Game ID",
    sortable: true,
  },
  {
    slug: "multiplier",
    label: "Extracted Number",
    type: "chip",
    sortable: true,
  },
  {
    slug: "amount",
    label: "Amount / Amount (EUR)",
    sortable: true,
  },
  {
    slug: "win",
    label: "Win / Win (EUR)",
    sortable: true,
  },
  {
    slug: "table",
    label: "Table",
    sortable: true,
  },
  {
    slug: "type",
    label: "Bet Count",
    sortable: false,
  },
  {
    slug: "created_at",
    label: "Start Time",
    type: "date",
    sortable: true,
  },
  {
    slug: "updated_at",
    label: "Updated At",
    type: "date",
    sortable: true,
  },
  {
    type: "action_button",
    label: "Action",
    slug: "actions",
  },
]);

const spinFilters = ref([
  {
    label: "Player ID",
    type: "text",
    placeholder: "Search for Player ID",
    property: "player_id",
  },
  {
    label: "Round ID",
    type: "text",
    placeholder: "Search for Round ID",
    property: "round_id",
  },
  {
    label: "Bet ID",
    type: "text",
    placeholder: "Search for Bet ID",
    property: "bet_id",
  },
  {
    label: "Game ID",
    type: "text",
    placeholder: "Search for Game ID",
    property: "game_id",
  },
  {
    label: "Start Date",
    isDateTime: true,
    placeholder: "From Start Date",
    property: "start_date",
  },
  {
    label: "End Date",
    isDateTime: true,
    placeholder: "To End Date",
    property: "end_date",
  },
]);
</script>

<style scoped></style>
